
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionChronology2018() {
  return (
    <>
      <div className="section section-dark gradient-background-claro" style={{ paddingBottom: "0px" }} >

        <div className="title gradient-title">
          <h2 align='center' style={{ marginBottom: '0px', marginTop: '0px', paddingBottom: '30px', paddingTop: '30px' }} > Chronology </h2>
        </div>

        <Container className="tim-container">

          <div className="title">
            <h3>2018</h3>
          </div>

          <div id="typography">

            <Row>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > Early October </span>
                  Starting to study pixel art scaling algorithms.
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > October 14th </span>
                  First successful implementation of hqx algorithm in chars sprites in mugen, one of the pixel art
                  scaling algorithms developed by Maxim Stepin, used in emulators such as Nestopia, FCEUX, higan, Snes9x, ZSNES and many more.
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="First successful implementation of hqx algorithm."
                      src={require("assets/img/Development/hqx_1er.jpg")}
                    />
                  </Col>
                  <Col xs="12" lg="6">
                    <Row>
                      <Col xs="12">
                        <img
                          style={{ cursor: 'pointer' }}
                          width="100%"
                          alt="3× magnification with the nearest-neighbor interpolation."
                          src={require("assets/img/Development/Test_nn.jpg")}
                        />
                      </Col>
                      <Col xs="12">
                        <img
                          style={{ cursor: 'pointer' }}
                          width="100%"
                          alt="3× magnification with hq3x algorithm."
                          src={require("assets/img/Development/Test_hq3x.jpg")}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > November 3th </span>
                  Learned new technologies to automate part of the process and make it possible to rematerialize entire characters.
                </p>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > November 4th </span>
                  First successful adaptation of the palettes to the new sprites obtained by the hqx algorithm,
                  decreasing the size of the char drastically (from about 200MB per character to 40MB).
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="First successful adaptation of the palettes to the new sprites obtained by the hqx algorithm."
                      src={require("assets/img/Development/hqx_paletas_2do.jpg")}
                    />
                  </Col>
                </Row>
              </div>

              <div className="typography-line">
                <p>
                  <span className="note" style={{ top: "4px" }} > November 9th </span>
                  First char with all the sprites altered with the hqx algorithm, with all the animations and functional collision boxes.
                  Start of production of remastered chars using the hqx algorithm.
                </p>
                <Row style={{ width: "100%", marginTop: "20px" }}>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="First chars with all sprites altered with the hqx algorithm."
                      src={require("assets/img/Development/hqx_completos_3er.jpg")}
                    />
                  </Col>
                  <Col xs="12" sm="6">
                    <img
                      style={{ cursor: 'pointer' }}
                      width="100%"
                      alt="Kung-Lao hara-kiri test with the hqx algorithm."
                      src={require("assets/img/Development/hqx_completos_3er_2.jpg")}
                    />
                  </Col>
                </Row>
              </div>

            </Row>
          </div>

        </Container>
      </div>
    </>
  );
}

export default SectionChronology2018;
